import { Product, ProductFamily } from '../types/catalog'

export const families: { id: ProductFamily; label: string; blurb: string }[] = [
  {
    id: 'laine',
    label: 'Laine mérinos',
    blurb: 'Pelotes, écheveaux et toisons issues de notre troupeau, filées en Aveyron.',
  },
  {
    id: 'mohair',
    label: 'Mohair',
    blurb: 'Tricots en mohair de nos chèvres angora : chaud, léger, durable.',
  },
  {
    id: 'savons',
    label: 'Savons',
    blurb: 'Savons à froid au lait de brebis et à la lanoline, fabriqués à la ferme.',
  },
]

export const products: Product[] = [
  {
    id: 'pelote-naturelle',
    name: 'Pelote mérinos naturelle',
    family: 'laine',
    price: 12.5,
    unit: '100 g — aiguilles 4 mm',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf62b2e8-6589-4a7f-be33-60fe9243f4bb.jpg',
    description: 'Laine non teintée, écrue, filée à partir de la tonte de printemps.',
    tags: ['Non teintée', 'Filée en Aveyron'],
    stock: 'en-stock',
  },
  {
    id: 'echeveau-plantes',
    name: 'Écheveau teinté aux plantes',
    family: 'laine',
    price: 18,
    unit: '100 g — 400 m',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf62b2e8-6589-4a7f-be33-60fe9243f4bb.jpg',
    description: 'Teinture végétale garance, gaude ou indigo, chaque bain est unique.',
    tags: ['Teinture végétale', 'Série limitée'],
    stock: 'dernieres-pieces',
  },
  {
    id: 'toison-lavee',
    name: 'Toison brute lavée',
    family: 'laine',
    price: 26,
    unit: '1 kg',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf62b2e8-6589-4a7f-be33-60fe9243f4bb.jpg',
    description: 'Pour les fileuses : toison triée, lavée à l’eau de source, prête à carder.',
    tags: ['Brute', 'Filage'],
    stock: 'en-stock',
  },
  {
    id: 'laine-feutrer',
    name: 'Laine à feutrer',
    family: 'laine',
    price: 15,
    unit: '200 g — ruban cardé',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf62b2e8-6589-4a7f-be33-60fe9243f4bb.jpg',
    description: 'Ruban cardé souple, idéal pour le feutrage à l’aiguille ou à l’eau.',
    tags: ['Atelier', 'Cardée'],
    stock: 'en-stock',
  },
  {
    id: 'chaussettes-mohair',
    name: 'Chaussettes mohair',
    family: 'mohair',
    price: 24,
    unit: 'Du 36 au 46',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6fe9112-61ce-4bd1-903f-290f426fa7c7.jpg',
    description: 'Le classique de la ferme : chaudes, respirantes, tricotées en France.',
    tags: ['Best-seller', 'Tricoté en France'],
    stock: 'en-stock',
  },
  {
    id: 'echarpe-mohair',
    name: 'Écharpe mohair',
    family: 'mohair',
    price: 68,
    unit: '180 × 30 cm',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6fe9112-61ce-4bd1-903f-290f426fa7c7.jpg',
    description: 'Maille aérée et duveteuse, coloris écru, gris perle ou bleu lavande.',
    tags: ['3 coloris'],
    stock: 'en-stock',
  },
  {
    id: 'plaid-mohair',
    name: 'Plaid mohair',
    family: 'mohair',
    price: 145,
    unit: '130 × 180 cm',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6fe9112-61ce-4bd1-903f-290f426fa7c7.jpg',
    description: 'Une pièce pour la vie, tissée avec le mohair d’une seule tonte.',
    tags: ['Pièce d’exception'],
    stock: 'dernieres-pieces',
  },
  {
    id: 'bonnet-mohair',
    name: 'Bonnet mohair',
    family: 'mohair',
    price: 39,
    unit: 'Taille unique',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6fe9112-61ce-4bd1-903f-290f426fa7c7.jpg',
    description: 'Doublé en laine mérinos pour éviter toute démangeaison.',
    tags: ['Doublé mérinos'],
    stock: 'epuise',
  },
  {
    id: 'savon-lavande',
    name: 'Savon lait de brebis & lavande',
    family: 'savons',
    price: 6.5,
    unit: '100 g',
    image: 'https://cdn.magicpatterns.com/uploads/gVd1p7Crcb2wgNUgM3m3GK/image2-500x428.jpg',
    description: 'Saponifié à froid, lavande fine du causse, surgras 8 %.',
    tags: ['Fabriqué en Aveyron', 'Saponifié à froid'],
    stock: 'en-stock',
  },
  {
    id: 'coffret-fleuri',
    name: 'Coffret 3 savons fleuris',
    family: 'savons',
    price: 18,
    unit: '3 × 100 g',
    image: 'https://cdn.magicpatterns.com/uploads/8Gd4DNGxeuie791qAe3FgQ/image3-500x428.jpg',
    description: 'Trois moulages fleurs, feuille et couronne, dans leur boîte bois.',
    tags: ['Idée cadeau'],
    stock: 'en-stock',
  },
  {
    id: 'savon-lanoline',
    name: 'Savon lanoline & camomille',
    family: 'savons',
    price: 6.5,
    unit: '100 g',
    image: 'https://cdn.magicpatterns.com/uploads/7iV5n3vHebZGGaLS7ndWf7/image4.jpg',
    description: 'Riche en lanoline issue de nos toisons, pour les peaux sensibles.',
    tags: ['Peaux sensibles'],
    stock: 'en-stock',
  },
  {
    id: 'coffret-decouverte',
    name: 'Coffret découverte de la ferme',
    family: 'savons',
    price: 32,
    unit: '5 savons + 1 pelote',
    image: 'https://cdn.magicpatterns.com/uploads/ipxdfxDZsUJJowmCfKgeBM/image5-428x440.jpg',
    description: 'Notre sélection complète pour découvrir le travail du GAEC.',
    tags: ['Idée cadeau', 'Édition automne'],
    stock: 'dernieres-pieces',
  },
]
